import { useQuery } from "@apollo/react-hooks";
import { useState, useCallback, useEffect, useMemo } from "react";
import { GET_TYPE_TAX_VOUCHERS } from "./queries";

const INITIAL_STATE = {
  data: [],
  issueFiscalReceipts: false,
  isModalOpen: false,
  selectedReceipt: null,
  isLoading: false,
  query: "",
};

export default function useActions({ pharmacyProviderId }) {
  const [state, setState] = useState(INITIAL_STATE);
  const {
    data: { getTypeTaxVouchers } = {},
    loading: loadingTypeTaxVouchers,
    refetch: refetchTypeTaxVouchers,
  } = useQuery(GET_TYPE_TAX_VOUCHERS, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        pharmacyProviderId,
      },
    },
  });

  const onChange = useCallback((key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  }, []);

  const toggleModal = useCallback(async () => {
    setState((prevState) => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen,
    }));
    await refetchTypeTaxVouchers();
  }, [refetchTypeTaxVouchers]);

  const handleEdit = useCallback(async (receipt) => {
    try {
      setState((prevState) => ({
        ...prevState,
        selectedReceipt: receipt,
        isModalOpen: true,
      }));
    } catch (error) {
      throw new Error(error.message);
    }
  }, []);

  useEffect(() => {
    if (!loadingTypeTaxVouchers && getTypeTaxVouchers) {
      setState((prevState) => ({
        ...prevState,
        data: getTypeTaxVouchers || [],
      }));
    }
  }, [loadingTypeTaxVouchers, getTypeTaxVouchers]);


  // Filtra los comprobantes por tipo, prefijo o último comprobante.
  const filteredData = useMemo(() => {
    const query = state.query.trim().toLowerCase();
    if (!query) return state.data;
    return state.data.filter((row) =>
      [row?.name, row?.prefix, row?.last, row?.lastSeq]
        .some((value) => String(value || "").toLowerCase().includes(query)),
    );
  }, [state.data, state.query]);

  return [
    { state, filteredData },
    {
      onChange,
      toggleModal,
      handleEdit,
    },
  ];
}
